import { financePaymentCreateForMasterAPI } from "@/views/FinancePaymentCreateForMaster/services/api";

export const readFinancePaymentCreateForMaster = async (projectId) => {
  try {
    const params = {};
    if (projectId !== null && projectId !== undefined && projectId !== "") {
      params.project_id = projectId;
    }

    const res = await financePaymentCreateForMasterAPI.read(params);
    return {
      rows: res?.data || [],
      notices: res?.notices || [],
    };
  } catch (e) {
    console.error("Error reading finance payments create-for-master:", e);
    throw e;
  }
};

export const createFinancePaymentCreateForMaster = async (projectIdList) => {
  const payload = {
    project_id_list: projectIdList === null ? null : projectIdList,
  };
  const res = await financePaymentCreateForMasterAPI.create(payload);
  return res;
};

export const createFinancePaymentCreateForMasterByRemontCosts = async (remontCostsIdList) => {
  const payload = {
    remont_costs_id_list: remontCostsIdList === null ? null : remontCostsIdList,
  };
  const res = await financePaymentCreateForMasterAPI.create(payload);
  return res;
};

export const sendFinancePaymentsToBi = async () => {
  const res = await financePaymentCreateForMasterAPI.sendToBi();
  return res;
};

export const readFinancePaymentBiReport = async (dateFrom, dateTo, withError = false) => {
  const body = { with_error: !!withError };
  if (!withError) {
    if (dateFrom !== null && dateFrom !== undefined && dateFrom !== "") {
      body.date_from = dateFrom;
    }
    if (dateTo !== null && dateTo !== undefined && dateTo !== "") {
      body.date_to = dateTo;
    }
  }
  const res = await financePaymentCreateForMasterAPI.report(body);
  return res?.data || [];
};

export const readFinancePaymentBiReportDetail = async (financePaymentId) => {
  const res = await financePaymentCreateForMasterAPI.reportDetail(financePaymentId);
  return res?.data || [];
};

export const columns = [
  { name: "select", field: "project_id", label: "", align: "left", sortable: false, style: "width: 44px" },
  { name: "project_info", field: "resident_name", label: "Проект", align: "left", sortable: true, style: "min-width: 250px" },
  { name: "agreement_info", field: "agreement_num", label: "Договор", align: "left", sortable: true, style: "min-width: 200px" },
  { name: "contractor_name", field: "contractor_name", label: "Подрядчик", align: "left", sortable: true },
  { name: "payment_sum", field: "payment_sum", label: "К оплате", align: "right", sortable: true, style: "width: 160px" },
];

